import { render } from "./CardDetails.vue?vue&type=template&id=b05ed3ce&scoped=true"
import script from "./CardDetails.vue?vue&type=script&lang=js"
export * from "./CardDetails.vue?vue&type=script&lang=js"

import "./CardDetails.vue?vue&type=style&index=0&id=b05ed3ce&scoped=true&lang=css"

import exportComponent from "/Users/patrykslak/Documents/wbtank/wbtank-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b05ed3ce"]])

export default __exports__